import React, { useState, useEffect } from "react";
import "../styles/styles.css";
import { useLocation, Link } from "react-router-dom";

const Navbar = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showFooter, setShowFooter] = useState(false);
  const [logo, setLogo] = useState(isMobile ? "/Logo_only.png" : "/Logo.png");

  const isActive = (path) => location.pathname === path;

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      setLogo(mobile ? "/Logo_only.png" : "/Logo.png");
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Call on mount

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleFooter = () => {
    setShowFooter(!showFooter);
  };

  // Mobile Navbar
  if (isMobile) {
    return (
      <nav className={`mobile-nav ${menuOpen ? "menu-open" : ""}`}>
        <div className="mobile-nav-wrapper">
          <button
            className={`hamburger ${menuOpen ? "open" : ""}`}
            onClick={toggleMenu}
          >
            <div></div>
            <div></div>
            <div></div>
          </button>
          <Link to="/">
            <img className="mobile_logo" src={logo} alt="Company Logo" />
          </Link>
        </div>
        <div className={`menu-wrapper ${menuOpen ? "active" : ""}`}>
          <div className={`menu-wrapper-list ${menuOpen ? "active" : ""}`}>
            <ul>
              <li
                className={`menu-wrapper-list-items ${
                  isActive("/about") ? "active" : ""
                }`}
              >
                <Link className="menu-wrapper-list-item" to="/about">
                  About Us
                </Link>
              </li>
              <li
                className={`menu-wrapper-list-items ${
                  isActive("/services") ? "active" : ""
                }`}
              >
                <Link className="menu-wrapper-list-item" to="/services">
                  Services
                </Link>
              </li>
              <li
                className={`menu-wrapper-list-items ${
                  isActive("/Insights") ? "active" : ""
                }`}
              >
                <Link className="menu-wrapper-list-item" to="/insights">
                  Insights
                </Link>
              </li>
              <li
                className={`menu-wrapper-list-items ${
                  isActive("/career") ? "active" : ""
                }`}
              >
                <Link className="menu-wrapper-list-item" to="/career">
                  Career
                </Link>
              </li>
              <li
                className={`menu-wrapper-list-items ${
                  isActive("/contact") ? "active" : ""
                }`}
              >
                <Link className="menu-wrapper-list-item" to="/contact">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div className={`menu-wrapper-divider ${menuOpen ? "active" : ""}`} />
          <div className={`box_socials ${menuOpen ? "active" : ""}`}>
            <div className="box_social_links">
              <div className="box_social_link">
                <div className="social_title">Location</div>
                <a className="box_socials_link" href="maps location">
                  Kathmandu, Nepal
                </a>
              </div>
              <div className="box_social_link">
                <div className="social_title">Contacts</div>
                <a className="box_socials_link" href="email1">
                  email1
                </a>
                <a className="box_socials_link" href="email1">
                  Phonenumber
                </a>
              </div>
            </div>

            <div className="box_social_icons">
              <a
                href="linkedin-page-link"
                target="blank"
                rel="noopener noreferrer"
              >
                <img
                  className="box_social_icons_img"
                  src="/mobile-linkedin-icon.png"
                  alt="Linkedin"
                />
              </a>
              <a
                href="facebook-page-link"
                target="blank"
                rel="noopener noreferrer"
              >
                <img
                  className="box_social_icons_img"
                  src="/mobile-facebook-icon.png"
                  alt="Facebook"
                />
              </a>
            </div>
          </div>
          <div
            className={`menu-site-disclaimer-wrapper ${
              menuOpen ? "active" : ""
            }`}
          >
            <a className="menu-site-disclaimer" href="asd">
              Terms of Use
            </a>
            <a className="menu-site-disclaimer" href="adfg">
              Privacy Policy
            </a>
          </div>
        </div>
      </nav>
    );
  }

  // Desktop Navbar
  return (
    <nav>
      <div className="desktop-nav-wrapper">
        <div className="desktop-nav_logo">
          <Link to="/" className="logo">
            <img className="desktop_logo" src={logo} alt="Company Logo" />
          </Link>
        </div>
        <div className="desktop-nav_tags">
          <ul className="desktop-nav-ul">
            <li
              className={`desktop-nav-list ${
                isActive("/about") ? "active" : ""
              }`}
            >
              <div
                className={`desktop-nav-item-wrapper ${
                  isActive("/about") ? "active" : ""
                }`}
              >
                <Link
                  className={`desktop-nav-item ${
                    isActive("/about") ? "active" : ""
                  }`}
                  to="/about"
                >
                  About Us
                </Link>
              </div>
            </li>
            <li
              className={`desktop-nav-list ${
                isActive("/services") ? "active" : ""
              }`}
            >
              <div
                className={`desktop-nav-item-wrapper ${
                  isActive("/services") ? "active" : ""
                }`}
              >
                <Link
                  className={`desktop-nav-item ${
                    isActive("/services") ? "active" : ""
                  }`}
                  to="/services"
                >
                  Services
                </Link>
              </div>
            </li>
            <li
              className={`desktop-nav-list ${
                isActive("/insights") ? "active" : ""
              }`}
            >
              <div
                className={`desktop-nav-item-wrapper ${
                  isActive("/insights") ? "active" : ""
                }`}
              >
                <Link
                  className={`desktop-nav-item ${
                    isActive("/insights") ? "active" : ""
                  }`}
                  to="/insights"
                >
                  Insights
                </Link>
              </div>
            </li>
            <li
              className={`desktop-nav-list ${
                isActive("/career") ? "active" : ""
              }`}
            >
              <div
                className={`desktop-nav-item-wrapper ${
                  isActive("/career") ? "active" : ""
                }`}
              >
                <Link
                  className={`desktop-nav-item ${
                    isActive("/career") ? "active" : ""
                  }`}
                  to="/career"
                >
                  Career
                </Link>
              </div>
            </li>
          </ul>
        </div>
        <button
          className={`desktop-nav-contact ${showFooter ? "active" : ""}`}
          onClick={toggleFooter}
        >
          Contact Us
        </button>
      </div>
      <div className={`footer-wrapper ${showFooter ? "active" : ""}`} onDoubleClick={toggleFooter}>
        <div className="footer-content-wrapper">
          <div className="footer-contact-wrapper">
            <div className="footer-contact">
              <div className="footer-contact-companyname">
                <div>S.B. Sharma & Associates </div>
                <div>Chartered Accountants</div>
              </div>
              <div className="footer-contact-title">Location</div>
              <a
                className="footer-contact-text"
                href="https://maps.app.goo.gl/XDsCML5oJ4cwrszU7"
                onClick={toggleFooter}
              >
                Kathmandu-11, Thapathali, Panchayan Marg
              </a>
              <div className="footer-contact-title">Email</div>
              <a
                className="footer-contact-text"
                href="mailto:email@example.com"
                onClick={toggleFooter}
              >
                email
              </a>
              <div className="footer-contact-title">Phone Number</div>
              <a
                className="footer-contact-text"
                href="Tel:9860101337"
                onClick={toggleFooter}
              >
                9860101337
              </a>
            </div>
            <div className="footer-contact-links">
              <a
                href="linkedin-page-link"
                target="blank"
                rel="noopener noreferrer"
                onClick={toggleFooter}
              >
                <img
                  className="footer-contact-icons"
                  src="/linkedin-icon.png"
                  alt="Linkedin"
                />
              </a>
              <a
                href="facebook-page-link"
                target="blank"
                rel="noopener noreferrer"
                onClick={toggleFooter}
              >
                <img
                  className="footer-contact-icons"
                  src="/facebook-icon.png"
                  alt="Facebook"
                />
              </a>
            </div>
          </div>
          <div className="footer-links-wrapper">
            <div className="footer-links-title">Resources</div>
            <div className="footer-links">
              <div className="footer-link">
                <Link
                  className="footer-link-item"
                  to="/about"
                  onClick={toggleFooter}
                >
                  About Us
                </Link>
              </div>
              <div className="footer-link">
                <Link
                  className="footer-link-item"
                  to="/services"
                  onClick={toggleFooter}
                >
                  Services
                </Link>
              </div>
              <div className="footer-link">
                <Link
                  className="footer-link-item"
                  to="/contact"
                  onClick={toggleFooter}
                >
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-disclaimers-wrapper">
          <div className="footer-disclaimer">
            <p>
              © 2025 S. B. Sharma & Associates Pvt. Ltd. | Certified ISO
              9001:2015
            </p>
          </div>
          <div className="footer-disclaimer">
            <a
              className="footer-disclaimer"
              href="/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
